import OrderState from '~/constants/common/OrderState';
import { useUserPurchasing } from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useGetIsVehiclePurchasedByUser() {
  const { orderState, vehicle: { vehicleId: purchasingVehicleId = 0 } = {} } =
    useUserPurchasing();
  const { vehicleId: currentVehicleId = 0 } = useGetVehicleDetails();

  return (
    purchasingVehicleId === currentVehicleId &&
    orderState === OrderState.RecentlyPurchased
  );
}
